const ph = {
  ph1: { name: 'Herstellen', desc: 'z.B. Lebensmittel, Kleidung', },
  ph2: { name: 'Reparieren', desc: 'z.B. Elektrogeräte, Fahrzeuge', },
  ph3: { name: 'Aufbauen', desc: 'z.B.Häuser, Straßen, Brücken', },
  ph4: { name: 'Gestalten', desc: 'z.B. Frisuren, Backwaren, Schaufenster', },
  ph5: { name: 'Zusammenbauen', desc: 'z.B. Möbel, Heizungsanlagen, Motoren', },
  ph6: { name: 'Bearbeiten', desc: 'z.B. Material, Holz, Metall, Steine', },
  ph7: { name: 'Verarbeiten', desc: 'z.B. Kochen, Backen', },
  ph8: { name: 'Pflegen und hegen', desc: 'z.B. Gärten, Wälder, Parkanlagen', },
  ph9: { name: 'Bedienen', desc: 'z.B. Maschinen, Anlagen, Geräte', },
  ph10: { name: 'Installieren', desc: 'z.B. Leitungen, Rohre, Anlagen', },
}

export default ph



// WEBPACK FOOTER //
// ./src/store/ph.js